module.exports = __webpack_public_path__ + "img/dead-end.40d700f0.svg";